import * as _ from "lodash";
import * as moment from "moment-timezone";
import * as React from "react";
import styled from "styled-components";

import { Label } from "src/library/components/Forms";
import { CheckboxStyled } from "src/library/components/Forms/Checkbox";
import Grid from "src/library/components/Hedron";
import {
  IDeliveryRoute,
  DeliveryRouteType,
  WeekDayName
} from "src/core/drops/api/drops.api";

interface IDeliveryDaysPickerProps {
  value: IDeliveryRoute | null;
  inherited: IDeliveryRoute | null;
  handleChange: (deliveryRoute: IDeliveryRoute | null) => void;
  deliveryRoutes: IDeliveryRoute[];
  isGlobal?: boolean;
  type: DeliveryRouteType;
  disabled?: boolean;
}

const DeliveryDaysPicker: React.ReactFCWithChildren<IDeliveryDaysPickerProps> = ({
  value, handleChange, isGlobal, type, disabled
}) => {
  React.useEffect(() => {
    if (value && value.type !== type) {
      handleChange({
        type,
        name: null,
        deliveryDays: {},
        id: 0,
        entityId: null
      });
    }
  }, [ type ]);

  const handleSetDay = (weekDay: WeekDayName) => {
    if (value) {
      if (_.has(value.deliveryDays, weekDay)) {
        handleChange({
          ...value,
          deliveryDays: _.omit(value.deliveryDays, weekDay)
        });
      } else {
        handleChange({
          ...value,
          deliveryDays: {
            ...value.deliveryDays,
            [ weekDay ]: moment
              .utc()
              .isoWeekday(weekDay)
              .isoWeekday()
          }
        });
      }
    }
  };

  const isChecked = (weekday: WeekDayName) => {
    if (value) {
      return _.has(value.deliveryDays, weekday);
    }

    return false;
  };

  return (
    <Grid.Bounds direction="vertical">
      {(!isGlobal || type === "global") &&
        _.map([
          1,
          2,
          3,
          4,
          5,
          6,
          7
        ], day => {
          // @ts-ignore
          const weekDay: WeekDayName = moment
            .utc()
            .isoWeekday(day)
            .format("dddd");

          return (
            <DeliveryDayWrapper
              direction="horizontal"
              key={day}
            >
              <Grid.Box>
                <CheckboxStyled
                  disabled={disabled}
                  name={`delivery-day-${day}`}
                  id={`delivery-day-${day}`}
                  checked={isChecked(weekDay)}
                  onChange={() => handleSetDay(weekDay)}
                />
              </Grid.Box>

              <LabelWrapper>
                <Label
                  for={`delivery-day-${day}`}
                  label={weekDay}
                />
              </LabelWrapper>
            </DeliveryDayWrapper>
          );
        })}
    </Grid.Bounds>
  );
};

const DeliveryDayWrapper = styled(Grid.Bounds)`
  padding-top: ${({ theme }) => theme.spacing.padding.xs};
`;

const LabelWrapper = styled(Grid.Box)`
  padding-left: ${({ theme }) => theme.spacing.padding.md};
`;

export default DeliveryDaysPicker;
